var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import qs from "qs";
export class MapboxAPIClass {
    constructor(opts) {
        this.request = (opts) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios({
                    url: `https://api.mapbox.com${opts.path}`,
                    method: opts.method || "get",
                    data: opts.data || {},
                });
                return response.data;
            }
            catch (e) {
                if (e.response && e.response.data) {
                    throw e.response.data;
                }
                else {
                    throw e;
                }
            }
        });
        this.directions = (profile, from, to, opts) => __awaiter(this, void 0, void 0, function* () {
            const query = qs.stringify(Object.assign({ access_token: this.opts.api_key }, (opts || {})));
            const coordinates = `${from[0]},${from[1]};${to[0]},${to[1]}`;
            const path = `/directions/v5/${profile}/${coordinates}?${query}`;
            return this.request({ method: "get", path: path });
        });
        this.geocode_autocomplete = (search, opts) => __awaiter(this, void 0, void 0, function* () {
            const query = qs.stringify(Object.assign({ access_token: this.opts.api_key }, (opts || {})));
            const searchText = encodeURI(search);
            return this.request({
                method: "get",
                path: `/geocoding/v5/mapbox.places/${searchText}.json?${query}`,
            });
        });
        this.opts = opts;
    }
}
//# sourceMappingURL=index.js.map